(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["miraya-shipping-progress"] && !Shopify.designMode) return;
  try {
    (function(){
  function setup(){
    var meter=document.querySelector('[data-miraya-shipping-progress]');
    var subtotal=document.querySelector('[data-cart-subtotal]');
    if(!meter||!subtotal||meter.dataset.ready)return;
    meter.dataset.ready='true';
    var timer;
    var version=0;
    function update(){
      var current=++version;
      var root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
      fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'})
        .then(function(response){if(!response.ok)throw new Error('cart');return response.json();})
        .then(function(cart){
          if(current!==version||!meter.isConnected)return;
          meter.hidden=cart.currency!=='JOD'||cart.item_count===0;
          if(meter.hidden)return;
          var remaining=Math.max(0,2500-cart.total_price);
          var amount=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'JOD',minimumFractionDigits:2,maximumFractionDigits:3}).format(remaining/100);
          meter.querySelector('[data-miraya-shipping-message]').textContent=remaining>0?meter.dataset.remaining.replace('__AMOUNT__',amount):meter.dataset.qualified;
          meter.querySelector('[data-miraya-shipping-fill]').style.width=Math.min(100,cart.total_price/2500*100)+'%';
        }).catch(function(){meter.hidden=true;});
    }
    new MutationObserver(function(){clearTimeout(timer);timer=setTimeout(update,120);}).observe(subtotal,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["miraya-storage-rack"] && !Shopify.designMode) return;
  try {
    function initialiseStorageRacks() {
    document.querySelectorAll('[data-rack-section]').forEach((card) => {
      if (card.dataset.ready) return;
      const root = document.getElementById('ProductSection-' + card.dataset.rackSection);
      if (!root) return;
      const selectors = Array.from(root.querySelectorAll('.single-option-selector'));
      const variants = JSON.parse(card.querySelector('[data-rack-variants]').textContent);
      const soldOut = card.querySelector('[data-rack-sold-out]').textContent;
      let lastVariant = null;
      function update(changeMedia = false) {
        const selected = selectors.map((select) => select.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        selectors.forEach((select, index) => {
          Array.from(select.options).forEach((option) => {
            const available = variants.some((item) => item.available && item.options[index] === option.value && item.options.every((value, other) => other === index || value === selected[other]));
            option.textContent = option.value + (available ? '' : ' — ' + soldOut);
          });
        });
        if (!variant) return;
        card.querySelector('[data-rack-status]').textContent = variant.status;
        if (changeMedia && variant.id !== lastVariant) {
          const thumbnail = root.querySelector('[data-thumbnail-id="' + card.dataset.rackSection + '-' + variant.media + '"]');
          if (thumbnail) thumbnail.click();
          lastVariant = variant.id;
        }
      }
      selectors.forEach((select) => select.addEventListener('change', () => queueMicrotask(() => update(true))));
      card.dataset.ready = 'true';
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseStorageRacks);
  else initialiseStorageRacks();
  document.addEventListener('shopify:section:load', initialiseStorageRacks);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["miraya-variant-info"] && !Shopify.designMode) return;
  try {
    function initialiseVariantReviews() {
    document.querySelectorAll('[data-variant-review]').forEach((card) => {
      if (card.dataset.ready) return;
      const root = document.getElementById('ProductSection-' + card.dataset.variantReview);
      if (!root) return;
      const variants = JSON.parse(card.querySelector('[data-variant-review-json]').textContent);
      const selectors = Array.from(root.querySelectorAll('.single-option-selector'));
      const soldOut = card.querySelector('[data-variant-sold-out]').textContent;
      const status = card.querySelector('[data-variant-status]');
      const measurement = card.querySelector('[data-variant-measurement]');
      let lastVariant;
      function update(changeMedia = false) {
        const selected = selectors.map((select) => select.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        selectors.forEach((select, index) => {
          Array.from(select.options).forEach((option) => {
            const available = variants.some((item) => item.available && item.options[index] === option.value && item.options.every((value, other) => other === index || value === selected[other]));
            option.textContent = option.value + (available ? '' : ' — ' + soldOut);
          });
        });
        status.textContent = variant ? variant.status : card.querySelector('[data-variant-invalid]').textContent;
        measurement.textContent = variant ? variant.measurement : '';
        measurement.hidden = !measurement.textContent;
        if (variant && changeMedia && variant.id !== lastVariant && variant.media) {
          const thumbnail = root.querySelector('[data-thumbnail-id="' + card.dataset.variantReview + '-' + variant.media + '"]');
          if (thumbnail) thumbnail.click();
        }
        lastVariant = variant && variant.id;
      }
      selectors.forEach((select) => select.addEventListener('change', () => queueMicrotask(() => update(true))));
      card.dataset.ready = 'true';
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseVariantReviews);
  else initialiseVariantReviews();
  document.addEventListener('shopify:section:load', initialiseVariantReviews);
  } catch(e) { console.error(e); }
})();

})();
